import { render, staticRenderFns } from "./create_model.vue?vue&type=template&id=303df174&scoped=true"
import script from "./create_model.vue?vue&type=script&lang=js"
export * from "./create_model.vue?vue&type=script&lang=js"
import style0 from "./create_model.vue?vue&type=style&index=0&id=303df174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303df174",
  null
  
)

export default component.exports